<div class="propero-shell">
  <header class="pl-header">
    <div class="pl-container pl-header__inner">
      <div class="pl-header__left">
        <a routerLink="/main" class="pl-logo" (click)="closeMobileMenu()">
          PROPERO<span class="pl-logo__accent">.IO</span>
        </a>

        <nav class="pl-nav pl-nav--desktop" aria-label="Principal">
          <a class="pl-nav__link" routerLink="/main" fragment="home" routerLinkActive="pl-nav__link--active" [routerLinkActiveOptions]="{ exact: false }">
            {{ 'LAYOUT.MENU_HOME' | translate }}
          </a>
          <a class="pl-nav__link" routerLink="/main" fragment="services" routerLinkActive="pl-nav__link--active">
            {{ 'LAYOUT.MENU_SOLUTIONS' | translate }}
          </a>
          <a class="pl-nav__link" routerLink="/products" routerLinkActive="pl-nav__link--active">
            {{ 'LAYOUT.MENU_PRODUCTS' | translate }}
          </a>
          <a class="pl-nav__link" routerLink="/pricing" routerLinkActive="pl-nav__link--active">
            {{ 'LAYOUT.MENU_FINANCIAL_PLAN' | translate }}
          </a>
          <a class="pl-nav__link" routerLink="/main" fragment="resources" routerLinkActive="pl-nav__link--active">
            {{ 'LAYOUT.MENU_RESOURCES' | translate }}
          </a>
          <a class="pl-nav__link" routerLink="/blog-list" routerLinkActive="pl-nav__link--active">
            {{ 'LAYOUT.MENU_BLOG' | translate }}
          </a>
          <a class="pl-nav__link" routerLink="/about-us" routerLinkActive="pl-nav__link--active">
            {{ 'LAYOUT.MENU_ABOUT' | translate }}
          </a>
          <a class="pl-nav__link" routerLink="/contact" routerLinkActive="pl-nav__link--active">
            {{ 'LAYOUT.MENU_CONTACT' | translate }}
          </a>
        </nav>
      </div>

      <div class="pl-header__actions">
        <div class="pl-lang pl-lang--desktop">
          <button
            *ngFor="let lang of translate.getLangs()"
            type="button"
            class="pl-lang__btn"
            [class.pl-lang__btn--active]="translate.currentLang === lang"
            (click)="onChangeLanguage(lang)">
            {{ lang }}
          </button>
        </div>

        <div class="pl-user pl-user--desktop" *ngIf="isLoggedIn && user">
          <button type="button" class="pl-user__trigger" (click)="toggleUserDropdown()" [attr.aria-expanded]="isUserDropdownOpen">
            <i class="lni lni-user"></i>
            <span>{{ user?.name || user?.username || 'Profile' }}</span>
            <i class="lni lni-chevron-down"></i>
          </button>
          <div class="pl-user__menu" *ngIf="isUserDropdownOpen">
            <button type="button" class="pl-user__item" (click)="navigateToProfile()">
              <i class="lni lni-user"></i>
              {{ 'LAYOUT.MENU_PROFILE' | translate }}
            </button>
            <button type="button" class="pl-user__item" (click)="logout()">
              <i class="lni lni-exit"></i>
              {{ 'LAYOUT.MENU_LOGOUT' | translate }}
            </button>
          </div>
        </div>

        <a *ngIf="!isLoggedIn" [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="pl-login pl-login--desktop">
          {{ 'LAYOUT.MENU_LOGIN' | translate }}
        </a>

        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="pl-cta-assistant">
          Propero Assistant
        </a>

        <button
          type="button"
          class="pl-menu-toggle"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-label="Meniu">
          <i class="lni" [ngClass]="mobileMenuOpen ? 'lni-close' : 'lni-menu'"></i>
        </button>
      </div>
    </div>

    <div class="pl-mobile-nav" *ngIf="mobileMenuOpen">
      <nav class="pl-container pl-mobile-nav__inner" aria-label="Mobil">
        <a class="pl-mobile-nav__link" routerLink="/main" fragment="home" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_HOME' | translate }}
        </a>
        <a class="pl-mobile-nav__link" routerLink="/main" fragment="services" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_SOLUTIONS' | translate }}
        </a>
        <a class="pl-mobile-nav__link" routerLink="/products" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_PRODUCTS' | translate }}
        </a>
        <a class="pl-mobile-nav__link" routerLink="/pricing" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_FINANCIAL_PLAN' | translate }}
        </a>
        <a class="pl-mobile-nav__link" routerLink="/main" fragment="resources" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_RESOURCES' | translate }}
        </a>
        <a class="pl-mobile-nav__link" routerLink="/blog-list" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_BLOG' | translate }}
        </a>
        <a class="pl-mobile-nav__link" routerLink="/about-us" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_ABOUT' | translate }}
        </a>
        <a class="pl-mobile-nav__link" routerLink="/contact" (click)="closeMobileMenu()">
          {{ 'LAYOUT.MENU_CONTACT' | translate }}
        </a>

        <div class="pl-lang pl-lang--mobile">
          <button
            *ngFor="let lang of translate.getLangs()"
            type="button"
            class="pl-lang__btn"
            [class.pl-lang__btn--active]="translate.currentLang === lang"
            (click)="onChangeLanguage(lang)">
            {{ lang }}
          </button>
        </div>

        <ng-container *ngIf="isLoggedIn && user; else mobileLogin">
          <button type="button" class="pl-mobile-nav__link" (click)="navigateToProfile(); closeMobileMenu()">
            {{ 'LAYOUT.MENU_PROFILE' | translate }}
          </button>
          <button type="button" class="pl-mobile-nav__link" (click)="logout(); closeMobileMenu()">
            {{ 'LAYOUT.MENU_LOGOUT' | translate }}
          </button>
        </ng-container>
        <ng-template #mobileLogin>
          <a class="pl-mobile-nav__link" [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">
            {{ 'LAYOUT.MENU_LOGIN' | translate }}
          </a>
        </ng-template>
      </nav>
    </div>
  </header>

  <main class="pl-main">
    <router-outlet></router-outlet>
  </main>

  <a routerLink="/main" fragment="home" class="pl-back-top" aria-label="Înapoi sus">
    <i class="lni lni-chevron-up"></i>
  </a>

  <footer class="pl-footer">
    <div class="pl-container pl-footer__grid">
      <div class="pl-footer__col">
        <div class="pl-logo pl-logo--footer">
          PROPERO<span class="pl-logo__accent">.IO</span>
        </div>
        <h5 class="pl-footer__label">{{ 'LAYOUT.CONTACT_US' | translate }}</h5>
        <div class="pl-footer__contact">
          <p>{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</p>
          <p>{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</p>
          <p class="pl-footer__muted">DPO: dpo@propero.io</p>
        </div>
      </div>

      <div class="pl-footer__col">
        <h5 class="pl-footer__heading">{{ 'LAYOUT.SUPPORT' | translate }}</h5>
        <ul class="pl-footer__links">
          <li><a routerLink="/contact">{{ 'LAYOUT.CONTACT_US' | translate }}</a></li>
          <li><a routerLink="/legal/privacy">{{ 'LAYOUT.LEGAL_ADVISORY' | translate }}</a></li>
          <li><a routerLink="/legal/privacy-policy">{{ 'LAYOUT.LEGAL_PRIVACY_POLICY' | translate }}</a></li>
          <li><a routerLink="/legal/cookie-preferences">{{ 'LAYOUT.LEGAL_COOKIE_PREFERENCES' | translate }}</a></li>
          <li><a routerLink="/legal/terms">{{ 'LAYOUT.LEGAL_TERMS' | translate }}</a></li>
          <li><a routerLink="/sitemap">{{ 'LAYOUT.MENU_SITEMAP' | translate }}</a></li>
        </ul>
      </div>

      <div class="pl-footer__col">
        <h5 class="pl-footer__heading">{{ 'LAYOUT.MENU_COMPANY' | translate }}</h5>
        <ul class="pl-footer__links">
          <li><a routerLink="/about-us">{{ 'LAYOUT.MENU_ABOUT_US' | translate }}</a></li>
          <li><a routerLink="/careers">{{ 'LAYOUT.MENU_CAREERS' | translate }}</a></li>
          <li><a routerLink="/blog-list">{{ 'LAYOUT.MENU_BLOG' | translate }}</a></li>
          <li><a routerLink="/collaboration">{{ 'LAYOUT.MENU_COLLABORATION' | translate }}</a></li>
          <li><a routerLink="/collaboration" fragment="owner">{{ 'LAYOUT.MENU_COLLABORATION_OWNER' | translate }}</a></li>
          <li><a routerLink="/collaboration" fragment="manager">{{ 'LAYOUT.MENU_COLLABORATION_MANAGER' | translate }}</a></li>
          <li><a routerLink="/collaboration" fragment="agent">{{ 'LAYOUT.MENU_COLLABORATION_AGENT' | translate }}</a></li>
        </ul>
      </div>

      <div class="pl-footer__col">
        <h5 class="pl-footer__heading">{{ 'LAYOUT.MENU_MOBILE' | translate }} &amp; {{ 'LAYOUT.MENU_PAYMENT' | translate }}</h5>
        <div class="pl-footer__stores">
          <a
            *ngIf="footerLinks.stores?.googlePlay"
            [href]="footerLinks.stores.googlePlay"
            target="_blank"
            rel="noopener noreferrer"
            class="pl-store-badge">
            Google Play
          </a>
          <a
            *ngIf="footerLinks.stores?.appStore"
            [href]="footerLinks.stores.appStore"
            target="_blank"
            rel="noopener noreferrer"
            class="pl-store-badge">
            App Store
          </a>
        </div>
        <h6 class="pl-footer__label pl-footer__label--sm">{{ 'LAYOUT.MENU_PAYMENT' | translate }}</h6>
        <div class="pl-footer__payments">
          <span>Visa</span>
          <span>Mastercard</span>
          <span>G Pay</span>
          <span>Stripe</span>
        </div>
      </div>
    </div>

    <div class="pl-container pl-footer__bottom">
      <p class="pl-footer__copy">
        © {{ currentYear }} Propero.io. {{ 'LAYOUT.MENU_ALL_RIGHTS_RESERVED' | translate }}
      </p>
      <div class="pl-footer__social">
        <a
          *ngIf="footerLinks.social?.facebook"
          [href]="footerLinks.social.facebook"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook">
          <i class="lni lni-facebook-filled"></i>
        </a>
        <a
          *ngIf="footerLinks.social?.twitter"
          [href]="footerLinks.social.twitter"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X (Twitter)">
          <i class="lni lni-twitter-original"></i>
        </a>
        <a
          *ngIf="footerLinks.social?.instagram"
          [href]="footerLinks.social.instagram"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram">
          <i class="lni lni-instagram-original"></i>
        </a>
        <a
          *ngIf="footerLinks.social?.linkedin"
          [href]="footerLinks.social.linkedin"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn">
          <i class="lni lni-linkedin-original"></i>
        </a>
      </div>
    </div>
  </footer>
</div>
